@if (dashboardType === 'SUPERSET') {
  <iframe [src]="selectedUrl" width="100%"
  height="90%"></iframe>
  }<!-- this will change in the future if we make that a client can have more than one different endpoint to show-->

  @if (dashboardType === 'SMART_COFFEE') {
    <div>
      <app-dashboards-charts></app-dashboards-charts>
    </div>
  }